import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import SecurityDepositPolicy from "./SecurityDepositPolicy";

export default function ChargesSummary({ advancePaymentData, totalGuests}) {
  const needsPayment =
    advancePaymentData?.requires_payment ||
    advancePaymentData?.requires_security_deposit ||
    advancePaymentData?.next_action === "SECURITY_DEPOSIT_AUTH" ||
    advancePaymentData?.next_action === "FLASH_OFFER_PAYMENT";

  if (!needsPayment) return null;

  const perPersonAmount = advancePaymentData?.policy_summary?.per_person_amount || 0;
  const depositAmount = advancePaymentData?.deposit_summary?.authorized_amount || 0;
  const subtotal = totalGuests * perPersonAmount;
  const depositCurrency = advancePaymentData?.deposit_summary?.currency || advancePaymentData?.gateway?.currency || "";
  const currencySymbol = depositCurrency === "GBP" ? "£" : depositCurrency === "USD" ? "$" : depositCurrency === "EUR" ? "€" : depositCurrency === "INR" ? "₹" : "₹";

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom align="left" fontSize="15px">
        Charges Summary
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography fontSize="13px" color="text.secondary">
            Security deposit per guest
          </Typography>
          <Typography fontSize="13px" fontWeight={600}>
            {currencySymbol}
            {perPersonAmount}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography fontSize="13px" color="text.secondary">
            Number of guests
          </Typography>
          <Typography fontSize="13px" fontWeight={600}>
            × {totalGuests}
          </Typography>
        </Box>

        {totalGuests > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography fontSize="13px" color="text.secondary">
              Subtotal
            </Typography>
            <Typography fontSize="13px" fontWeight={600}>
              {currencySymbol}
              {subtotal}
            </Typography>
          </Box>
        )}

        <Divider sx={{ my: 1 }} />

        {subtotal !== depositAmount && (
          <Typography fontSize="12px" color="text.secondary" sx={{ mb: 1 }}>
            The hold is {currencySymbol}{depositAmount}. It can differ from guests times the per-guest rate when a minimum party size applies.
          </Typography>
        )}

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography fontSize="14px" fontWeight={600}>
            Total security deposit
          </Typography>
          <Typography fontSize="16px" fontWeight={700} color="primary.main">
            {currencySymbol}
            {depositAmount}
          </Typography>
        </Box>
      </Paper>
      <SecurityDepositPolicy />
    </Box>
  );
}